import { Component, OnInit, Input } from '@angular/core';
import { HeaderItemType } from '../models/header-item-type.enum';
import { IHeaderModel } from '../models/header.model';
import { StrictValuePipe } from '../../../shared/pipes/strict-value.pipe';

@Component({
  selector: 'app-table-row',
  templateUrl: './table-row.component.html',
})
export class TableRowComponent implements OnInit {
  @Input() header?: IHeaderModel;
  @Input() item?: any;

  public headerType: typeof HeaderItemType = HeaderItemType;

  constructor(private strictValuePipe: StrictValuePipe) {}

  ngOnInit(): void {}

  setItem(item: any, header: IHeaderModel): any {
    return this.getProperty(header.name, item);
  }

  setItemArray(item: any, header: IHeaderModel): string {
    let value = '';
    header.properties?.forEach((element, id, arr) => {
      if (this.getProperty(element, item)) {
        value = value + this.getProperty(element, item)!;
        if (id != arr.length - 1) {
          value = value + ', ';
        }
      }
    });
    return value;
  }

  getProperty(path: string, obj: any): any {
    const properites = Array.isArray(path) ? path : path.split('.');
    return (properites as any[]).reduce(
      (prev: any, curr: any) => prev && prev[curr],
      obj
    );
  }

  setStrictValue(item: any, header: IHeaderModel): string {
    return this.strictValuePipe.transform(
      this.setItem(item, header),
      header.strictValues!
    );
  }

  showItem(value: any): boolean {
    if (value || value == 0) {
      return true;
    }
    return false;
  }
}
